import { Text as rText } from "react-native";
import { defaultFontStyle } from "./defaultStyle";
import { styled } from "../css/styled";
export var Text = styled(rText, {
    themeKey: "text",
    defaultVariant: "body"
})(defaultFontStyle);
